﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';

const bb1 = 'bb1';
const bb2 = 'bb2';
const bb3 = 'bb3';
const bb4 = 'bb4';
const bb5 = 'bb5';
const bb6 = 'bb6';
const bb7 = 'bb7';
const bb8 = 'bb8';
const bb9 = 'bb9';
const bb10 = 'bb10';

const bbValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'bb1',
        value: bb1,
        tekst: 'bb1',
    },
    {
        id: 'bb2',
        value: bb2,
        tekst: 'bb2',
    },
    {
        id: 'bb3',
        value: bb3,
        tekst: 'bb3',
    },
    {
        id: 'bb4',
        value: bb4,
        tekst: 'bb4',
    },
    {
        id: 'bb5',
        value: bb5,
        tekst: 'bb5',
    },
    {
        id: 'bb6',
        value: bb6,
        tekst: 'bb6',
    },
    {
        id: 'bb7',
        value: bb7,
        tekst: 'bb7',
    },
    {
        id: 'bb8',
        value: bb8,
        tekst: 'bb8',
    },
    {
        id: 'bb9',
        value: bb9,
        tekst: 'bb9',
    },
    {
        id: 'bb10',
        value: bb10,
        tekst: 'bb10',
    },
];

export default {
    bb1: bb1,
    bb2: bb2,
    bb3: bb3,
    bb4: bb4,
    bb5: bb5,
    bb6: bb6,
    bb7: bb7,
    bb8: bb8,
    bb9: bb9,
    bb10: bb10,

    bbValg,
};
